/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import './UploadButton.scss';
import PlusIcon from 'assets/icons/icon-plus.svg';
import {
  isIOS,
} from 'react-device-detect';

const UploadButton = props => (
  <button type="button" name={props.name} className="upload-file" htmlFor="uploadInput" onClick={e => props.onClick(e)}>
    {props.img && (
    <div className="upload-file__image" style={{ backgroundImage: `url(${props.img})` }}>
      {/* <img src={props.img} alt={props.name} /> */}
    </div>
    )}
    {!props.img && (
    <div className="upload-file__button">
      <span className="upload-file__button__icon" name={props.name}>
        <img className={isIOS ? 'ios-plus-img' : ''} src={PlusIcon} alt={props.label} />
      </span>
      <FormattedMessage id={props.label} />
    </div>
    )}
  </button>
);

UploadButton.propTypes = {
  /** upload label */
  label: PropTypes.string,
  //   /** upload event */
  //   onChange: PropTypes.func,
  /** uploaded image */
  img: PropTypes.string,
  /** on button click event */
  onClick: PropTypes.func,
};

UploadButton.defaultProps = {
  label: 'step.idPassport.upload.selfie',
  //   onChange: () => {},
  img: null,
  onClick: () => {},
};

export default UploadButton;
